/** @param {unknown} epochMsOrSec */
export function directoryTimestampToDate(epochMsOrSec) {
  const n = Number(epochMsOrSec);
  if (!Number.isFinite(n)) return null;
  const ms = n < 1e12 ? n * 1000 : n;
  return new Date(ms);
}

/** @param {unknown} epochMsOrSec */
export function formatDirectoryDateTime(epochMsOrSec) {
  const d = directoryTimestampToDate(epochMsOrSec);
  if (!d || Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}
